import React, { Component } from 'react';
import { connect } from 'react-redux';
import localeMap from 'constants/localeMap';
import { activityWidgetScript, hrefUrl, partnerId } from './constants';
import ActivityWidgetComponent from './ActivityWidgetComponent';

class ActivityWidget extends Component {
  componentDidMount() {
    const script = document.createElement('script');
    script.src = activityWidgetScript;
    script.async = true;
    script.defer = true;
    script.setAttribute('data-gyg-partner-id', partnerId);
    document.head.appendChild(script);
  }

  componentWillUnmount() {
    const script = document.querySelector(`script[src="${activityWidgetScript}"]`);
    if (script) {
      document.head.removeChild(script);
    }
  }

  render() {
    const { destination, tld, language } = this.props;

    return (
      <ActivityWidgetComponent
        destination={destination}
        tld={tld}
        language={localeMap[language]}
        hrefUrl={hrefUrl}
        partnerId={partnerId}
      />
    );
  }
}

function mapStateToProps(state) {
  return {
    tld: state.settings.value.tld,
    language: state.settings.value.locale.language,
  };
}

export default connect(mapStateToProps)(ActivityWidget);
